import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const AnexoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ANEXO' htmlFor='input-anexo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='anexo'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-anexo'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(AnexoFormGroup)
